import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'

/**
 * Route guard for the subscription-gated Agent detail surfaces.
 *
 * When the tenant has no Agents contract, `/agents` itself renders the
 * not-subscribed preview card (see pages/Agents.tsx), but an agent deep link
 * would otherwise bypass that and render the full editor. Redirect to `/agents`
 * so the preview card is the single not-subscribed destination.
 *
 * UX gate only, NOT the security boundary — server-side entitlement checks
 * remain the enforcement layer.
 */
export function RequireAgentsContract({ children }: { children: ReactNode }) {
  const { agentsContracted } = useAuth()
  return agentsContracted ? <>{children}</> : <Navigate to="/agents" replace />
}
